module.exports = __webpack_public_path__ + "media/bootstrap-icons/cash-ddf02b07.svg";